export const FILTER_MODAL_SCROLL_CONTAINER_ID = 'filter-modal-scroll-container';
export const FILTER_DESKTOP_SCROLL_CONTAINER_ID = 'filter-scroll-container';
